var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _PageTransition_instances, handleClick_fn, fadeOutAndNavigate_fn;
import { C as Component } from "./component-cLJ9vlHA.js";
import "./critical-Da0Dmhh9.js";
import "./utilities-2Suih3Nm.js";
class PageTransition extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _PageTransition_instances);
  }
  connectedCallback() {
    super.connectedCallback();
    requestAnimationFrame(() => {
      delete this.dataset.entering;
    });
    window.addEventListener("pageshow", (e) => {
      if (e.persisted) {
        delete this.dataset.entering;
        delete this.dataset.exiting;
      }
    });
    document.addEventListener("click", __privateMethod(this, _PageTransition_instances, handleClick_fn).bind(this));
  }
}
_PageTransition_instances = new WeakSet();
/** Intercept internal link clicks and trigger fade-out before navigation. */
handleClick_fn = function(e) {
  var _a;
  if (e.defaultPrevented) return;
  const target = (_a = e.target) == null ? void 0 : _a.closest("a");
  if (!target) return;
  if (target.download || target.target === "_blank" || target.dataset.noTransition) return;
  if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
  const href = target.getAttribute("href");
  if (!href) return;
  let url;
  try {
    url = new URL(href, location.href);
  } catch {
    return;
  }
  const normalizePath = (p) => p || "/";
  const samePage = url.origin === location.origin && normalizePath(url.pathname) === normalizePath(location.pathname);
  if (samePage) return;
  if (url.protocol === "mailto:" || url.protocol === "tel:" || url.protocol === "javascript:") return;
  e.preventDefault();
  __privateMethod(this, _PageTransition_instances, fadeOutAndNavigate_fn).call(this, url.href);
};
/** Fade out, then navigate. */
fadeOutAndNavigate_fn = function(href) {
  this.dataset.exiting = "";
  const timer = setTimeout(() => {
    window.location.href = href;
  }, 300);
  setTimeout(() => {
    delete this.dataset.entering;
    delete this.dataset.exiting;
  }, 5e3);
  this.addEventListener("transitionend", () => {
    clearTimeout(timer);
    window.location.href = href;
  }, { once: true });
};
customElements.define("page-transition", PageTransition);
